import $ from "../libs/jquery-3.5.1.min.js";
import "../libs/css_browser_selector.js";
import Swiper from "../libs/swiper-bundle-8.2.2.min";
import {gsap} from "../libs/gsap/gsap-core.js";
import {Anim} from "./Anim.js";

export class MainApp {

  swiperSlider = [];
  currentLanguage = $("html").attr("lang");

  constructor() {

    // Create a CSS property for the window inner height
    document.documentElement.style.setProperty('--window-inner-height', window.viewport().height + "px");

    this.anim = new Anim();
    this.initTriggers();
    this.initScroll();
    this.initSliders();
    this.initAddToAny();
    this.initSmoothScroll();
    this.initSafari();

    $(window).off("resize").on("resize", $.proxy(function () {
      this.resize();
    }, this));
  }

  addToAnyOnShare(shareData) {

    // Get the right type of modal
    var modalWindow = $(this).hasClass("share-page") ? ".page-modal" : ".landmark-modal";
    var modalWindowEl = $(modalWindow);

    var newUrl = modalWindowEl.attr("data-a2a-url");

    // Modify the share by returning an object with a "url" property containing the new URL
    return {
      url: newUrl,
    };
  }

  initAddToAny() {
    // https://www.addtoany.com/buttons/customize/asynchronous_loading
    // https://www.addtoany.com/buttons/customize/events#modify-share

    // Setup AddToAny "onShare" callback function
    window.a2a_config = window.a2a_config || {};
    window.a2a_config.callbacks = window.a2a_config.callbacks || [];
    window.a2a_config.callbacks.push({
      //ready: this.addToAnyOnReady,
      share: this.addToAnyOnShare,
    });

    // Load AddToAny script asynchronously
    var scriptAddToAny = document.createElement('script');
    scriptAddToAny.async = true;
    scriptAddToAny.src = 'https://static.addtoany.com/menu/page.js';
    var scriptModule = document.getElementsByTagName('script')[0];
    scriptModule.parentNode.insertBefore(scriptAddToAny, scriptModule);
  }

  initTriggers() {
    // Open saved landmarks tab
    $("#saved-landmarks .landmarks-tab-trigger").off("click").on("click", function () {
      $("#saved-landmarks").toggleClass("shown");
      $(this).siblings(".landmarks-listing").stop().slideToggle();
    });

    // Language switcher
    $("#language-switcher").off("change").on("change", function (e) {
      window.location.href = $(this).val();
    });

    // Retrieve ticket page using ticket number
    $("#get-ticket-form").off("submit").on("submit", $.proxy(function (e) {
      e.preventDefault();
      var ticketNumber = $("#ticket-number", e.currentTarget).val().toUpperCase();

      if (ticketNumber !== "") {
        window.open("/" + this.currentLanguage + "/ticket/" + ticketNumber, "_self");
      }
    }, this));

    // Open Share Modal
    $('.share-btn').each(function () {
      $(this).off('click.share-btn').on('click.share-btn', function () {
        var modalWindow = $(this).hasClass("share-page") ? ".page-modal" : ".landmark-modal";
        var modalWindowEl = $(modalWindow);

        if (modalWindow === ".landmark-modal") {
          var shareUrl = $(this).data("modal-url");
          modalWindowEl.attr("data-a2a-url", shareUrl);

          var shareTitle = $(this).data("modal-title");
          modalWindowEl.attr("data-a2a-title", shareTitle);
        }

        $(modalWindow).fadeIn(300);
        $('.modal').fadeIn(300);
        $(modalWindow).css('display', 'flex');
      });
    });

    $('.modal').off('click').on('click', function () {
      $('.modal-share').fadeOut(300);
      $('.modal').fadeOut(300);
    });

    //HERO
    $('#hero-arrow').on('click', function () {
      gsap.to("html, body", 0.5, {
        scrollTop: $('#ticket-itinerary').offset().top,
      });
    });

    //ANCHORS
    $('.ticket-itinerary').on('click', function () {
      gsap.to("html, body", 0.5, {
        scrollTop: $('#ticket-itinerary').offset().top - 100,
      });
    });
    $('.ticket-landmarks').on('click', function () {
      gsap.to("html, body", 0.5, {
        scrollTop: $('#ticket-landmarks').offset().top - 100,
      });
    });
    $('.ticket-selfies').on('click', function () {
      gsap.to("html, body", 0.5, {
        scrollTop: $('#ticket-selfies').offset().top - 100,
      });
    });
  }

  initScroll() {
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 100) {
        $('header').addClass('fixed');
      } else {
        $('header').removeClass('fixed')
      }
    });

    if ($(window).scrollTop() >= 100) {
      $('header').addClass('fixed');
    } else {
      $('header').removeClass('fixed')
    }
  }

  initSliders() {

    // Swiper container
    var slidersFields = [
      '#ticket-itinerary .swiper-desktop',
      '#ticket-landmarks .swiper',
    ];

    $.each($(slidersFields), $.proxy(function (index, el) {
      this.swiperSlider.push(new Swiper(el, {
        loop: false,
        threshold: 10,
        speed: 500,
        grabCursor: true,
        watchSlidesProgress: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        on: {
          init: function (swiper) {
            if (window.innerWidth <= 600) {
              swiper.destroy(true, true)
            }
            $(window).on("resize", $.proxy(function () {
              for (var i = 0; i < this.swiperSlider.length; i++) {
                this.swiperSlider[i].update();
              }
            }, this))
          },
        },
        breakpoints: {
          400: {
            slidesPerView: 'auto',
          },
        },
      }));
    }, this))

    $('#ticket-itinerary .swiper-mobile .swiper-wrapper .container-scroll').each(function () {
      var $this = $(this);
      var length = $(this).find('.group-landmarks .landmark-item').length;

      if (length === 1) {
        $this.addClass('one');
      }
      $this.find("h3.landmark-title").insertBefore($this);
    });


    $('#ticket-itinerary .swiper .swiper-wrapper .swiper-slide').each(function () {
      var number = $(this).find('.group-landmarks .landmark-item').length;

      if (number <= 1) {
        $(this).addClass('alone');
      }
    });

    var sliderSelfies = [
      '#ticket-selfies .swiper'
    ]

    $.each($(sliderSelfies), $.proxy(function (index, el) {
      this.swiperSlider.push(new Swiper(el, {
        allowTouchMove: false,
        slidesPerView: 3,
        spaceBetween: -35,
        threshold: 10,
        speed: 500,
        grabCursor: true,
        watchSlidesProgress: true,
        initialSlide: 0,
        navigation: {
          prevEl: $(el).find('.button-prev')[0],
          nextEl: $(el).find('.button-next')[0],
        },
        breakpoints: {
          600: {
            allowTouchMove: true,
          },
        },
        on: {
          init: function (swiper) {
            // Fetch selfies in ajax
            $.ajax({
              cache: false,
              dataType: "json",
              url: window.location.href.replace("ticket", "selfies"),
              success: function (response) {
                var files = response.media;

                if (files.length) {

                  // Sort file by name, alphabetically
                  files.sort((a, b) => {
                    if ((a.mediaType === "video" && b.mediaType !== "video") || (a.mediaType === b.mediaType && a.mediaId < b.mediaId)) {
                      return -1;
                    } else {
                      return 1;
                    }
                  });

                  // Append slide
                  var $slideClone = $(swiper.slides[0]).clone();
                  $.each(files, function (index, file) {

                    if (file.thumbnailURL) {
                      var appendSlide = false;
                      $slideClone.find("> a.image > img").attr("src", file.thumbnailURL);

                      if (file.mediaType === "photo") {
                        $slideClone.find("a.image").attr("href", file.thumbnailURL);
                        $slideClone.find("a.download").attr("href", file.thumbnailURL);
                        $slideClone.find("a.download").attr("download", "");
                        $slideClone.find("a.download > img").attr("src", "/images/icons/download.svg");
                        appendSlide = true;
                      } else if (file.mediaType === "video" && file.url) {
                        $slideClone.find("a.image").attr("href", file.url);
                        $slideClone.find("a.download").attr("href", file.url);
                        // $slideClone.find("a.download").removeAttr("download");
                        // $slideClone.find("a.download > img").attr("src", "/images/icons/external-link.png");
                        $slideClone.find("a.download").attr("download", "");
                        $slideClone.find("a.download > img").attr("src", "/images/icons/download.svg");
                        appendSlide = true;
                      }

                      if (appendSlide) {
                        swiper.appendSlide(
                          "<div class='swiper-slide'>" + $slideClone.html() + "</div>"
                        );
                      }
                    }
                  });

                  swiper.removeSlide(0); // remove clone slide
                  $("#ticket-selfies .swiper").removeClass("loading");
                  swiper.update();

                  if (swiper.slides.length < 3) {
                    $('#ticket-selfies .swiper').addClass('center');
                  } else {
                    $('#ticket-selfies .swiper').removeClass('center');
                  }

                  // Mobile only
                  if (window.innerWidth <= 600) {
                    // Set image count, destroy slider
                    $("#ticket-hero .ticket-selfies").closest(".item").removeClass("hidden");
                    swiper.destroy(true, true);
                  }
                } else {
                  $("#ticket-selfies").addClass("hidden");
                  $("#ticket-hero .ticket-selfies").closest(".item").addClass("hidden");
                  console.error("There's no selfie to load.");
                }
              },
              error: function () {
                $("#ticket-selfies").addClass("hidden");
                $("#ticket-hero .ticket-selfies").closest(".item").addClass("hidden");
                console.error("Error loading your selfies.");
              }
            });
            //Update
            $(window).on("resize", $.proxy(function () {
              for (var i = 0; i < this.swiperSlider.length; i++) {
                this.swiperSlider[i].update();
              }
            }, this))
          }
        },
      }));
    }, this))
  }

  initSmoothScroll() {
    var speed = 750; // Duration (ms)
    var headerOffset = -150;

    if ($(".anchors").length > 0) {
      $('.anchors .item').on('click', function () {
        var page = $(this).find('a').attr('href'); // Target
        $('html, body').animate({scrollTop: $(page).offset().top + headerOffset}, speed); // Go
        return false;
      });
    }
  }

  initSafari() {
    var browser = (function () {
      var test = function (regexp) {
        return regexp.test(window.navigator.userAgent)
      }
      switch (true) {
        case test(/edg/i):
          return "Microsoft Edge";
        case test(/trident/i):
          return "Microsoft Internet Explorer";
        case test(/firefox|fxios/i):
          return "Mozilla Firefox";
        case test(/opr\//i):
          return "Opera";
        case test(/ucbrowser/i):
          return "UC Browser";
        case test(/samsungbrowser/i):
          return "Samsung Browser";
        case test(/chrome|chromium|crios/i):
          return "Google Chrome";
        case test(/safari/i):
          return "Apple Safari";
        default:
          return "Other";
      }
    })();

    if (navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPhone/i) || (navigator.userAgent.match(/iPod/i))) {
      $('.swiper-mobile .swiper-slide').css('padding', '40px 24px');
    }
  }

  resize() {
    // Create a CSS property for the window inner height
    if (!$("html").is(".mobile")) {
      document.documentElement.style.setProperty('--window-inner-height', window.viewport().height + "px");
      $("#ticket-hero .ticket-selfies").closest(".item").removeClass("hidden");
    }
  }
}


